/** Response shapes of the reference lists served by `lib/cachedLookups`. */

/** Ids of rows in the `Configurations` table that the web app reads. */
export enum ConfigurationId {
	PhonePrefix = 1,
	Country = 2,
	PersonalIdLength = 3,
	PhoneLength = 6,
}

export interface NamedItem {
	id: number;
	description: string | null;
}

export type OrderStatus = NamedItem;
export type SettlementStatus = NamedItem;
export type UserRole = NamedItem;

export interface DocumentType extends NamedItem {
	documentTypeGroupId: number;
}

export interface CashRegister extends NamedItem {
	currencyId: number;
	currencyDescription: string | null;
}

export interface Customs extends NamedItem {
	costumsCode: string | null;
}

export interface Vat {
	id: number;
	value: number;
	countryId: number;
}

/** `GET User/userbyid` without an id: the logged-in user. */
export interface CurrentUser {
	id: number;
	nameAndSurname: string;
	businessName: string | null;
	email: string | null;
	username: string | null;
	phone: string | null;
	country: string | null;
	city: string | null;
	address: string | null;
	businessNumber: string | null;
	status: number | null;
	createdAt: string;
	zone: string | null;
	currencyDescription: string | null;
	currencySymbol: string | null;
	userRoleDescription: string | null;
	identificationNumber: string | null;
	userRoleId: number;
	showNumberInOrder: boolean | null;
	digitalDescription: string | null;
	serviceCostKs: number | null;
	serviceCostAl: number | null;
	serviceCostMk: number | null;
}
